import React from 'react'
import HeroPrivacyPolicy from '../../components/PrivacyPolicyComponent/HeroPrivacyPolicy'

const PrivacyPolicy = () => {
  return (
    <div className="my-10 py-10 sm:p-10">
      <HeroPrivacyPolicy />
    </div>
  )
}

export default PrivacyPolicy
